import { createSlice } from '@reduxjs/toolkit';
import { ILossBsosState } from '../types';
import { getLossBsos } from '../../service/api';

const initialState: ILossBsosState = {
  page: null,
  pending: false,
  error: null,
};

export const lossBsosSlice = createSlice({
  name: 'lossBsosSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLossBsos.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(getLossBsos.fulfilled, (state, action) => {
        state.page = action.payload;
        state.pending = false;
      })
      .addCase(getLossBsos.rejected, (state, action) => {
        if (action.error.message !== undefined) {
          state.error = action.error.message;
        }
        state.pending = true;
      });
  },
});

export default lossBsosSlice.reducer;
